import { AttachmentService } from 'src/app/services/attachment.service';
import { Vehicle } from 'src/app/models/Vehicle';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { ImageService } from 'src/app/services/image.service';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import {ImageHandlerModeTypeEnum} from 'src/app/models/enums/ImageHandlerModeTypeEnum'

@Component({
  selector: 'image-handler',
  templateUrl: './image-handler.component.html',
  styleUrls: ['./image-handler.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageHandlerComponent implements OnInit {

  @Input() vehicle:Vehicle;
  @Input() searchType:VehicleSearchTypeEnum;


  constructor(private attachmentService:AttachmentService,
    private cd: ChangeDetectorRef,
    private imageService: ImageService

    ) { }

  ngOnInit() {
  }
  get vehicleSearchTypeEnum(){
    return VehicleSearchTypeEnum;
  }

  getVehicleImageClass(vehciel:Vehicle){

    if(vehciel.vehicleImage==null){

      this.attachmentService.imageHandler(vehciel.classID,AttachmentScopesEnum.Vehicle,AttachmentTypeEnum.VehicleClassImg).subscribe((res)=>{

        vehciel.vehicleImage=res+'';//['result']
       // return vehciel.vehicleImage;
      // this.cd.markForCheck();
      })
    }

      return vehciel.vehicleImage;
  }
  getVehicleImageVehicle(vehciel:Vehicle){

    if(vehciel.vehicleImage==null){

      this.attachmentService.imageHandler(vehciel.vehicleID,AttachmentScopesEnum.Vehicle,AttachmentTypeEnum.VehicleImage).subscribe(res=>{
        vehciel.vehicleImage=res+'';//['result']
       // return vehciel.vehicleImage;
      // this.cd.markForCheck();
      })
    }

      return vehciel.vehicleImage;
  }
  getVehicleImageMMY(vehciel:Vehicle){
    if(vehciel.vehicleImage==null){

      this.attachmentService.imageHandler(vehciel.vehicleID,AttachmentScopesEnum.Vehicle,AttachmentTypeEnum.VehicleImage).subscribe(res=>{
        vehciel.vehicleImage=res+'';//['result']
       // return vehciel.vehicleImage;
      // this.cd.markForCheck();
      })
    }

      return vehciel.vehicleImage;
  }
  onVehicleImageClicked(vehicle:Vehicle){

    vehicle.isImageClicked=true;
    this.imageService.updateVehicleImage(vehicle);
  }
}
